import React from 'react';

import colors from '@front/common/src/utils/colors';
import { formatPrice, formatPricePerHour } from '@front/common/src/utils/formatting';
import { isHourlyBasedReference } from '@front/common/src/utils/universes';

import { SurchargesProps } from '@front/customer/src/components/basket/types';

import { translate } from '@front/i18n';

import Text from '@front/web-ui/src/components/base-text/variants/text';

import { CategoryLine, SurchargeLine, SurchargeTitle } from './common';

const t = translate('basket');

const Surcharges = ({
  appointmentSurcharge = 0,
  appointmentSurchargeReason,
  minPriceSurcharge = 0,
  universeReference,
}: SurchargesProps) => {
  const hasAppointmentSurcharge = appointmentSurcharge > 0 && appointmentSurchargeReason;
  const hasMinPriceSurcharge = minPriceSurcharge > 0;
  const isHourlyBasedUniverse = isHourlyBasedReference(universeReference);

  if (!hasAppointmentSurcharge && !hasMinPriceSurcharge) return null;

  return (
    <CategoryLine>
      <SurchargeTitle display='block'>
        {t('.surcharge.title', {
          count: hasAppointmentSurcharge && hasMinPriceSurcharge ? 2 : 1,
        })}
      </SurchargeTitle>
      {hasAppointmentSurcharge && (
        <SurchargeLine>
          <Text>{t(`.appointment_surcharge.${appointmentSurchargeReason}`)}</Text>
          <Text.SM color={colors.ink50}>
            {isHourlyBasedUniverse ? formatPricePerHour(appointmentSurcharge) : formatPrice(appointmentSurcharge)}
          </Text.SM>
        </SurchargeLine>
      )}
      {hasMinPriceSurcharge && (
        <SurchargeLine>
          <Text>{t('.min_price')}</Text>
          <Text.SM color={colors.ink50}>{formatPrice(minPriceSurcharge)}</Text.SM>
        </SurchargeLine>
      )}
    </CategoryLine>
  );
};

export default Surcharges;
